import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/button/button";
import { useUserContext } from "../../utils/userContext";
import Input from "../../../components/input/input";

function AdminUser() {
    const { users, fetchUsers, searchUser, searchedUser, userHasMore } = useUserContext();
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchUsers(true);
    }, [fetchUsers]);

    const handleNavigate = (id) => {
        navigate(`${id}`);
    }
    
    useEffect(() => {
        searchUser(searchTerm);
    }, [searchTerm, searchUser]);

    return (
        <div className="pageContainer">
            <h1>User</h1>
            <div className='adUsSearchContainer'>
                <Input
                    inputValue={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    inputType='text'
                    inputId='searchCustomer'
                    inputName='searchCustomer'
                    width='100%'
                    borderColor='black'
                    placeholder='Kunde suchen...'
                />
                <Button buttonValue='User hinzufügen' onClick={() => navigate('new')} />
            </div>
            {!searchTerm && (
                <div className="adUsCardContainer">
                    {users.map((user) => (
                        <div 
                            className="adUsContainer"
                            key={user._id} 
                            onClick={() => handleNavigate(user._id)}
                        >
                            <p><b>Kunde:</b> {user.prename} {user.name}</p>
                            <p><b>Email:</b> {user.email}</p>
                            <p><b>Firma:</b> {user.companyName || 'Kein Firmenname angegeben'}</p>
                            <p><b>Rolle: </b>{user.role}</p>
                            <p><b>Angemeldet seit: </b>{user.signedUpAt ? new Date(user.signedUpAt).toLocaleDateString() : 'Datum nicht verfügbar'}</p>
                        </div>
                    ))}
                </div>
            )}
            {searchTerm && searchedUser.length > 0 && (
                <div className="adUsCardContainer">
                    {searchedUser.map((user) => (
                        <div 
                            className="adUsContainer"
                            key={user._id} 
                            onClick={() => handleNavigate(user._id)}
                        >
                            <p><b>Kunde:</b> {user.prename} {user.name}</p>
                            <p><b>Email:</b> {user.email}</p>
                            <p><b>Firma:</b> {user.companyName || 'Kein Firmenname angegeben'}</p>
                            <p><b>Rolle: </b>{user.role}</p>
                            <p><b>Angemeldet seit: </b>{user.signedUpAt ? new Date(user.signedUpAt).toLocaleDateString() : 'Datum nicht verfügbar'}</p>
                        </div>
                    ))}
                </div>
            )}

            {searchTerm && searchedUser.length === 0 && (
                <p>Keine Ergebnisse gefunden.</p>
            )}

            {userHasMore && !searchTerm && (
                <Button
                    buttonValue='Mehr laden'
                    onClick={() => fetchUsers(false)}
                />
            )}

            {!userHasMore && users.length > 0 && (
                <p style= {{ textAlign: 'center' }}>Alle User geladen</p>
            )}
        </div>
    );
}

export default AdminUser;